var map = {
	"./aia.svg": 3032,
	"./ant.svg": 3033,
	"./aus.svg": 3034,
	"./bah.svg": 3035,
	"./ban.svg": 3036,
	"./bar.svg": 3037,
	"./ber.svg": 3038,
	"./biz.svg": 3039,
	"./bot.svg": 3040,
	"./bru.svg": 3041,
	"./can.svg": 3042,
	"./cay.svg": 3043,
	"./cmr.svg": 3044,
	"./cok.svg": 3045,
	"./cyp.svg": 3046,
	"./dma.svg": 3047,
	"./eng.svg": 3048,
	"./fij.svg": 3049,
	"./flk.svg": 3050,
	"./gab.svg": 3051,
	"./gam.svg": 3052,
	"./ggy.svg": 3053,
	"./gha.svg": 3054,
	"./gib.svg": 3055,
	"./grn.svg": 3056,
	"./guy.svg": 3057,
	"./ind.svg": 3058,
	"./iom.svg": 3059,
	"./ivb.svg": 3060,
	"./jam.svg": 3061,
	"./jey.svg": 3062,
	"./ken.svg": 3063,
	"./kir.svg": 3064,
	"./lca.svg": 3065,
	"./les.svg": 3066,
	"./manifest.json": 867,
	"./mas.svg": 3067,
	"./maw.svg": 3068,
	"./mdv.svg": 3069,
	"./mlt.svg": 3070,
	"./moz.svg": 3071,
	"./mri.svg": 3072,
	"./msr.svg": 3073,
	"./nam.svg": 3074,
	"./nfk.svg": 3075,
	"./ngr.svg": 3076,
	"./nir.svg": 3077,
	"./niu.svg": 3078,
	"./nru.svg": 3079,
	"./nzl.svg": 3080,
	"./pak.svg": 3081,
	"./png.svg": 3082,
	"./rsa.svg": 3083,
	"./rwa.svg": 3084,
	"./sam.svg": 3085,
	"./sco.svg": 3086,
	"./sey.svg": 3087,
	"./sgp.svg": 3088,
	"./shn.svg": 3089,
	"./skn.svg": 3090,
	"./sle.svg": 3091,
	"./sol.svg": 3092,
	"./sri.svg": 3093,
	"./svg-country.svg": 3094,
	"./swz.svg": 3095,
	"./tan.svg": 3096,
	"./tca.svg": 3097,
	"./tga.svg": 3098,
	"./tog.svg": 3099,
	"./tto.svg": 3100,
	"./tuv.svg": 3101,
	"./uga.svg": 3102,
	"./van.svg": 3103,
	"./wal.svg": 3104,
	"./zam.svg": 3105
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3031;